import { Injectable } from '@angular/core';
import {
    checkBoolean,
    getArrayField,
    decodeUtf8,
    getArray,
    verifyCustomEditorList,
    returnEmpty,
} from '@core/_utils/tools.utils';
import { DefaultSelect, BaseType } from '@documalis/_const/const';
import { ParseService } from './parse.service';
import { IndexedDbService } from './indexeddb.service';

@Injectable()
export class VariableListService {
    private isLoading = false;
    public customEditorList: any;
    private addMode = false;
    public groupVariableList: any;
    private verifyCustomEditorList = false;

    constructor(public parseService: ParseService, private indexedDbService: IndexedDbService) {}

    private getLocalStorage() {
        if (this.isLoading) {
            return;
        }
        this.groupVariableList = this.indexedDbService.groupVariable;
        this.isLoading = true;
    }
    
    public setCustomEditorList(aEditorList) {
        this.customEditorList = aEditorList;
        this.verifyCustomEditorList = verifyCustomEditorList(this.customEditorList);
    }

    public setIsLoading(aValue) {
        this.isLoading = aValue;
        this.parseService.setInitialized(aValue);
    }

    private initType(aType, aValue) {
        return {
            type: aType,
            dynName: aValue,
        };
    }

    private initData() {
        return {
            show: [],
            value: [],
        };
    }

    public setMode(aValue) {
        this.addMode = aValue;
    }

    // Lecture des paramètres de la requêtes avec :
    // - recherche du type d'éditeur
    // - chargement des combos
    public execParse(aData) {
        let varList = [];
        let varListParse = [];
        let wDefaultValue;
        let wOption: any;
        let wType;
        let wDynName: string;
        let wTypeName: any;
        varList = this.formatVarArray(aData);
        for (let item of varList) {
            wDefaultValue = decodeUtf8(this.parseService.execParse(item.DefaultValue));

            wTypeName = this.getType(item);
            wType = wTypeName.type;
            wDynName = wTypeName.dynName;

            switch (wType) {
                case 'DynamicIndex': {
                    wOption = this.getComboOption(item, wDynName);
                    item.value = this.getDefaultCombo(wType, wDefaultValue, wOption, '', '');
                    item.DefaultValue = item.value.displayValue;
                    break;
                }
                case 'Combo': {
                    wOption = this.getComboOption(item, item.EditorName);
                    item.value = this.getDefaultCombo(wType, wDefaultValue, wOption, '', '');
                    item.DefaultValue = item.value.displayValue;
                    break;
                }
                case 'ComboCustom':
                case 'ListDB':
                case 'ListUsers':
                case 'ListGroups': {
                    wOption = this.getComboCustomOption(item, wType);
                    item.value = this.getDefaultCombo(wType, wDefaultValue, wOption, '', '');
                    item.DefaultValue = item.value.displayValue;
                    break;
                }
                case 'Boolean': {
                    item.value = checkBoolean(wDefaultValue, true);
                    item.DefaultValue = wDefaultValue;
                    break;
                }
                default: {
                    item.value = wDefaultValue;
                    item.DefaultValue = wDefaultValue;
                    wOption = '';
                    break;
                }
            }
            varListParse.push(item);
        }
        return {
            VariableList: {
                Variable: varListParse,
            },
        };
    }

    public loadVariableList(aVarListAll, aVarList, aParent, aPath, aIsActiv) {
        // console.log('EditorService loadVariableList');
        // console.log('loadVariableList', aVarList);
        let wDefaultValue;
        let wType;
        let wOption: any;
        let wPattern: any;
        let wRequired = false;
        let wEditable = false;
        let wReadOnly = false;
        let wDisabled = false;
        let wChildPath = '';
        let wIsActiv: boolean;
        let wParent: string;
        let wDynName: string;
        let wTypeName: any;
        let wSystem: any;
        let wEditorName: string;

        for (let item of aVarList) {
            wIsActiv = aIsActiv;
            if (aParent === '') {
                wParent = '';
            } else {
                wParent = aParent;
            }
            wDefaultValue = this.getDefaultValue(item);

            wEditorName = '';
            wEditorName = this.getEditorName(item);

            wTypeName = this.getType(item);
            wType = wTypeName.type;
            wDynName = wTypeName.dynName;
            wRequired = this.getRequired(wType, item);
            wSystem = this.getSystem(item);
            wEditable = false;
            wDisabled = false;
            wReadOnly = checkBoolean(item.ReadOnly);
            if (aPath !== '') {
                wChildPath = aPath + '/' + item.Name + '=';
            } else {
                wChildPath = item.Name + '=';
            }

            switch (wType) {
                case 'separator': {
                    wOption = '';
                    item.value = '';
                    wDefaultValue = item.DefaultValue;
                    wReadOnly = true;
                    break;
                }
                case 'DynamicIndex': {
                    wOption = this.getComboOption(item, wDynName);
                    item.value = this.getDefaultCombo(item.Type, wDefaultValue, wOption, DefaultSelect, null);
                    break;
                }
                case 'Combo': {
                    wOption = this.getComboOption(item, item.EditorName);
                    item.value = this.getDefaultCombo(wType, wDefaultValue, wOption, '', '');
                    wEditable = this.getEditableCombo(item.EditorName);
                    if (wReadOnly === true) {
                        wEditable = false;
                    }
                    break;
                }
                case 'ComboCustom':
                case 'ListUsers':
                case 'ListGroups': {
                    wOption = this.getComboCustomOption(item, wType);
                    item.value = this.getDefaultCombo(wType, wDefaultValue, wOption, '', '');
                    break;
                }
                case 'ListDB': {
                    wOption = this.getComboCustomOption(item, wType);
                    item.value = this.getDefaultCombo(wType, wDefaultValue, wOption, '', '');
                    wEditable = this.getEditableComboDb(item.EditorName);
                    break;
                }
                case 'EditMask': {
                    wPattern = this.getPatternIfExist(item);
                    item.value = wDefaultValue;
                    wOption = '';
                    break;
                }
                default: {
                    item.value = wDefaultValue;
                    wOption = '';
                    break;
                }
            }

            const data = {
                name: item.Name,
                Label: item.Label,
                DefaultValue: wDefaultValue,
                value: item.value,
                type: wType,
                comboValue: wOption,
                Required: wRequired,
                system: wSystem,
                hidden: this.getHidden(item),
                pattern: wPattern,
                Editable: wEditable,
                ReadOnly: wReadOnly,
                disabled: wDisabled,
                parent: wParent,
                path: aPath,
                childPath: wChildPath,
                isActiv: wIsActiv,
                dynName: wDynName,
                EditorName: wEditorName,
                visible: wSystem === 'true' ? 0 : 1,
                operator: item.operator,
                displaydefault: item.displaydefault,
            };
            aVarListAll.push(data);

            if (wType === 'DynamicIndex') {
                wParent = item.Name;
                this.getDynValueList(aVarListAll, item, wParent, aPath, wIsActiv, wDynName);
            }
        }
    }

    private getDynValueList(aVarListAll, aItem, aParent, aPath, aIsActiv, wDynName) {
        let wValueList;
        let wVariableList;
        let wPath = '';
        let wIsActiv: boolean;
        let wValue;
        let wName;

        wValueList = this.getValueListFromCustomEditor(wDynName);
        wValue = this.getValueIfExist(aItem);

        for (const item of wValueList.Value) {
            // Lecture des groupes de variable
            if (Array.isArray(item.GroupVariableList)) {
                wVariableList = [];
            } else {
                wVariableList = this.getVariableListFromGroup(item.GroupVariableList);
                wVariableList.map((item) => {
                    if (BaseType.indexOf(item.Type) === -1) {
                        item.EditorName = item.Type;
                    }
                    return item;
                });
            }
            wIsActiv = false;

            wName = item.Name;

            if (wValue === wName && aIsActiv === true) {
                wIsActiv = true;
            }

            if (aPath !== '') {
                wPath = aPath + '/' + aParent + '=' + item.Name;
            } else {
                wPath = aParent + '=' + item.Name;
            }

            this.loadVariableList(aVarListAll, wVariableList, aParent, wPath, wIsActiv);
        }
    }

    private getValueIfExist(aItem) {
        let wRes = '';
        wRes = this.getDefValue(aItem);
        if (aItem.value) {
            if (aItem.value.retCode) {
                if (aItem.value.retCode !== '') {
                    wRes = aItem.value.retCode;
                }
            }
        }
        return wRes;
    }

    private getVariableListFromGroup(aName) {
        let wResult: any;
        this.getLocalStorage();
        // Nom de groupe avec " : impossible en saisie, mais gestion du cas (compatibilité)
        if (aName.substring(0, 1) === '"') {
            aName = aName.replace(/"/g, '');
        }
        const normalizedName = aName.toUpperCase();
        for (const item of this.groupVariableList.GroupVariable) {
            if (item.Information.Name.toUpperCase() === normalizedName) {
                if (item.VariableList) {
                    wResult = item;
                }
                break;
            }
        }
        if (wResult === undefined) {
            wResult = [];
        }
        wResult = this.formatVarArray(wResult);
        return wResult;
    }

    private getValueListFromCustomEditor(aName) {
        let wResult: any;
        wResult = this.getEditorItem(aName);
        if (wResult.DynamicIndex.ValueList) {
            wResult = wResult.DynamicIndex.ValueList;
        }
        return wResult;
    }

    private getEditorItem(aName) {
        let wResult: any;
        if (aName === undefined || aName === null) {
            return wResult;  
        }
        const normalizedName = aName.toUpperCase();
        this.getLocalStorage();
        if (this.verifyCustomEditorList === true) {
            for (const item of this.customEditorList.CustomEditor) {
                if (item.Information.Name.toUpperCase() === normalizedName) {
                    wResult = item;
                    break;
                }
            }
        }
        return wResult;    
    }

    private getDefValue(aItem) {
        let wDefaultValue = '';
        wDefaultValue = getArrayField(aItem.DefaultValue);
        if (typeof wDefaultValue === 'string') {
            if (wDefaultValue.substring(0, 2) === '<<') {
                wDefaultValue = this.parseService.execParse(wDefaultValue);
            }
        }
        return wDefaultValue;
    }

    private getType(aItem) {
        let wTypeName = this.initType('', '');
        if (aItem.Name !== '&SeparationLine') {
            wTypeName = this.getDetailType(aItem);
        } else {
            wTypeName = this.initType('separator', '');
        }
        return wTypeName;
    }

    private getDetailType(aItem) {
        let wType: string;
        let wEditorName = '';
        let wTypeName = this.initType('', '');
        if (BaseType.indexOf(aItem.Type) !== -1) {
            wType = aItem.Type;
        } else {
            wType = this.getTypeFromCustomEditorList(aItem.Type);
            if (BaseType.indexOf(wType) !== -1) {
                if (wType === 'DynamicIndex') {
                    wEditorName = aItem.Type;
                }
            }
        }
        wTypeName = this.initType(wType, wEditorName);
        if (aItem.EditorName === 'TextArea') {
            wTypeName = this.initType('TextArea', '');
        }
        if (aItem.EditorName === 'currency') {
            wTypeName = this.initType('InputCurrency', '');
        }
        return wTypeName;
    }

    private getRequired(aType, aItem) {
        if (aType === 'separator') {
            return false;
        } else {
            return checkBoolean(aItem.Required);
        }
    }

    private getDefaultValue(aItem) {
        let wRes;
        if (this.addMode === true) {
            wRes = this.getDefValue(aItem);
        } else {
            wRes = '';
        }
        return wRes;
    }

    private getEditorName(aItem) {
        let wRes = '';
        if (aItem.EditorName !== undefined) {
            wRes = aItem.EditorName;
        }
        return wRes;
    }

    private getSystem(aItem) {
        let wRes;
        if (aItem.System) {
            if (aItem.System === 'true') {
                wRes = 'true';
            } else {
                wRes = this.checkSys(aItem);
            }
        } else {
            wRes = this.checkSys(aItem);
        }
        return wRes;
    }

    private checkSys(aItem) {
        let wRes;
        if (this.getSys(aItem) === 'true') {
            wRes = 'true';
        } else {
            wRes = this.getHidden(aItem);
        }
        return wRes;
    }

    private getHidden(aItem) {
        if (aItem.Hidden) {
            return aItem.Hidden;
        } else {
            return this.getSys(aItem);
        }
    }

    private getSys(aItem) {
        if (aItem.Name.substring(0, 4) === 'sys_') {
            return 'true';
        } else {
            return 'false';
        }
    }

    public getTypeFromCustomEditorList(aName: any) {
        let wResult: any;
        wResult = this.getEditorItem(aName);
        if (wResult) {
            wResult = wResult.Information.Type_;
        } else {
            wResult = 'String';
        }
        return wResult;
    }

    private getDefaultCombo(aType, aDefaultValue, aOption, aDefDis, aDefRet) {
        let wValue = new Object();
        wValue = {
            displayValue: aDefDis,
            retCode: aDefRet,
        };
        if (aDefaultValue !== '') {
            wValue = this.getComboValue(aType, aDefaultValue, aOption);
        }
        return wValue;
    }

    public getComboValue(aType: string, aValue: any, aOptionList: any) {
        let wResult;
        const type = {
            ListUsers: this.getComboValue_combo,
            ListGroups: this.getComboValue_combo,
            ListDB: this.getComboValue_combo,
            ComboCustom: this.getComboValue_combo,
            Combo: this.getComboValue_code,
            DynamicIndex: this.getComboValue_code,
        };

        if (type[aType]) {
            wResult = type[aType](aValue, aOptionList, this.getComboValueKey);
        } else {
            wResult = this.getComboValueKey(aValue, aOptionList, 'retCode');
        }
        // Recherche de la valeur par défaut dans les 2 listes
        if (wResult.displayValue === '' && wResult.retCode === '') {
            wResult = this.getComboValueKey(aValue, aOptionList, 'retCode');
        }
        return wResult;
    }

    private getComboValue_combo(aValue, aOptionList, getComboValueKey) {
        return getComboValueKey(aValue, aOptionList, 'displayValue');
    }

    private getComboValue_code(aValue, aOptionList, getComboValueKey) {
        return getComboValueKey(aValue, aOptionList, 'retCode');
    }

    public getComboValueKey(aValue, aOptionList, aName) {
        let wValue = {
            displayValue: '',
            retCode: '',
        };
        for (let i = 0; i < aOptionList.length; i++) {
            if (returnEmpty(aOptionList[i][aName]).toUpperCase() === returnEmpty(aValue).toUpperCase()) {
                wValue.displayValue = aOptionList[i].displayValue;
                wValue.retCode = aOptionList[i].retCode;
                break;
            }
        }
        return wValue;
    }

    private getComboOption(aItem, aName) {
        let wOption = [];
        let wData = this.initData();
        if (aItem.Value) {
            wData = this.getSplitedValue(aItem.Value, aItem.Value);
            wOption = this.getArrayOption(wData);
        } else {
            wOption = this.getOptionComboValue(aName).option;
        }
        wOption = this.verifyOption(wOption);
        return wOption;
    }

    private getComboCustomOption(aItem, aType) {
        let wRes;
        let wOption = [];
        let wData = this.initData();
        if (aItem.MaskShow && aItem.MaskValue) {
            wData = this.getSplitedValue(aItem.MaskShow, aItem.MaskValue);
            wOption = this.getArrayOption(wData);
        } else {
            if (aType === 'ListDB') {
                wRes = this.getOptionComboDbValue(aItem.EditorName);
            } else {
                wRes = this.getOptionComboValue(aItem.EditorName);
            }
            if (wRes !== undefined) {
                wOption = wRes.option;
            }
        }
        wOption = this.verifyOption(wOption);
        return wOption;
    }
    
    private verifyOption(aOption) {
        if (aOption === undefined) {
            return [];
        } else {
            return aOption;
        }
    }

    public getOptionComboValue(aName: any) {
        let wResult: any;
        this.getLocalStorage();
        if (this.verifyCustomEditorList === true) {
            wResult = this.setResult(aName);
        }
        return wResult;
    }

    private getOptionComboDbValue(aName: any) {
        let wResult: any;
        this.getLocalStorage();
        if (this.verifyCustomEditorList === true) {
            wResult = this.getOptionComboValueDataDB(aName);
        }
        return wResult;
    }

    private getOptionComboValueDataDB(aName: any) {
        let wRes: any;
        let wData: any;
        let wResult: any;
        let wType = '';
        let wEditable = false;
        wResult = {
            data: wData,
            type: wType,
            Editable: wEditable,
        };
        wRes = this.getEditorItem(aName);
        if (wRes) {
            wData = this.getSplitValue(wRes);
            wEditable = checkBoolean(wRes.ListDB.Editable);
            wType = wRes.Information.Type_;
            wResult = {
                option: this.getArrayOption(wData),
                type: wType,
                Editable: wEditable,
            };
        }
        return wResult;
    }

    public getEditableCombo(aName) {
        let wRes: any;
        let wResult = false;
        wRes = this.getEditorItem(aName);
        if (wRes) {
            wResult = checkBoolean(wRes.Combo.Editable);
        }
        return wResult;
    }
    public getEditableComboDb(aName) {
        let wRes: any;
        let wResult = false;
        wRes = this.getEditorItem(aName);
        if (wRes) {
            wResult = checkBoolean(wRes.ListDB.Editable);
        }
        return wResult;
    }

    private setResult(aEditorName) {
        let wComboData: any;
        wComboData = this.getOptionComboValueData(aEditorName);
        return {
            type: wComboData.type,
            option: this.getArrayOption(wComboData.data),
            Editable: wComboData.Editable,
        };
    }

    public getOptionComboValueData(aName: any) {
        let wRes: any;
        let wData: any;
        let wResult: any;
        let wType = '';
        let wEditable = false;
        wResult = {
            data: wData,
            type: wType,
            Editable: wEditable,
        };
        wRes = this.getEditorItem(aName);
        if (wRes) {
            wResult = this.getComboValueData(wRes);
        }
        return wResult;
    }

    private getComboValueData(aItem) {
        let wData: any;
        let wType = '';
        let wEditable = false;
        if (aItem.Information.Type_ === 'DynamicIndex') {
            wData = this.getDynValue(aItem.DynamicIndex.ValueList);
        } else {
            wData = this.getSplitValue(aItem);
            wEditable = this.getComboEditable(aItem);
        }
        wType = aItem.Information.Type_;
        return {
            data: wData,
            type: wType,
            Editable: wEditable,
        };
    }

    private getComboEditable(aItem) {
        let wResult = false;
        if (aItem.Information.Type_ === 'Combo') {
            wResult = checkBoolean(aItem.Combo.Editable);
        }
        return wResult;
    }

    private getDynValue(aList) {
        let wShow = [];
        let wValue = [];
        wShow.push(DefaultSelect);
        wValue.push(null);
        for (const item of aList.Value) {
            wShow.push(item.Name);
            wValue.push(item.Name);
        }
        return {
            show: wShow,
            value: wValue,
        };
    }

    private getSplitValue(aItem) {
        switch (aItem.Information.Type_) {
            case 'Combo':
                return this.getComboOrdered(aItem);
            case 'ComboCustom':
                return this.getSplitedValue(aItem.ComboCustom.Show, aItem.ComboCustom.Value);
            case 'ListUsers':
                return this.getSplitedValue(aItem.ListUser.MaskShow, aItem.ListUser.MaskValue);
            case 'ListGroups':
                return this.getSplitedValue(aItem.ListGroup.MaskShow, aItem.ListGroup.MaskValue);
            case 'ListDB':
                return this.getSplitedValue(aItem.ListDB.MaskShow, aItem.ListDB.MaskValue);                            
        }
    }

    private getComboOrdered(aItem) {
        let wOrder = false;
        let wValue: any;
        wOrder = checkBoolean(aItem.Combo.Order);
        if (wOrder === false) {
            return this.getSplitedValue(aItem.Combo.Value, aItem.Combo.Value);
        } else {
            wValue = this.getSplitedValue(aItem.Combo.Value, aItem.Combo.Value);
            wValue.show.sort();
            wValue.value.sort();
            return wValue;
        }
    }

    private getPatternIfExist(aItem) {
        let wResult = {
            regExpr: '',
            flags: '',
        };
        if (aItem.RegExpr) {
            wResult = {
                regExpr: aItem.RegExpr,
                flags: this.getRegOption(aItem),
            };
        } else {
            wResult = this.getPattern(aItem.EditorName);
        }
        return wResult;
    }

    private getArrayOption(wData) {
        let wOption = [];
        if (wData !== undefined) {
            for (let i = 0; i < wData.show.length; i++) {
                if (wData.show[i] !== '') {
                    wOption.push({
                        displayValue: wData.show[i],
                        retCode: wData.value[i],
                    });
                }
            }
        }
        return wOption;
    }

    private getRegOption(aItem) {
        let wResult = '';
        if (aItem.GlobalSearch === 'true') {
            wResult = wResult.concat('g');
        }
        if (aItem.IgnoreCase === 'true') {
            wResult = wResult.concat('i');
        }
        if (aItem.Multiline === 'true') {
            wResult = wResult.concat('m');
        }
        return wResult;
    }

    public getPattern(aName) {
        let wRes: any;
        let wResult = {
            regExpr: '',
            flags: '',
        };
        wRes = this.getEditorItem(aName);
        if (wRes) {
            if (wRes.EditMask.RegExpr) {
                wResult = {
                    regExpr: wRes.EditMask.RegExpr,
                    flags: this.getRegOption(wRes.EditMask),
                };
            }            
        }
        return wResult;
    }

    private getSplitedValue(show, value) {
        try {
            if (show.length !== 0 && value.length !== 0) {
                return {
                    show: [...this.decodeValue(show.split('\n'))],
                    value: [...this.decodeValue(value.split('\n'))],
                };
            } else {
                return {
                    show: [],
                    value: [],
                };
            }
        } catch (e) {
            return {
                show: ['Error'],
                value: ['Error'],
            };
        }
    }

    private decodeValue(aData) {
        return aData.map((item) => {
            if (item !== '') {
                return decodeUtf8(item);
            }
            return item;
        });
    }

    public formatVarArray(aData) {
        let varList = [];
        let wSys: any;
        if (aData.VariableList === undefined) {
            return varList;
        }
        if (!Array.isArray(aData.VariableList.Variable)) {
            wSys = this.getSys(aData.VariableList.Variable);
            const wdata = {
                VariableList: {
                    Variable: [
                        {
                            Name: aData.VariableList.Variable.Name,
                            Label: aData.VariableList.Variable.Label,
                            DefaultValue: aData.VariableList.Variable.DefaultValue,
                            Required: aData.VariableList.Variable.Required,
                            Hidden: this.getHidden(aData.VariableList.Variable),
                            Type: aData.VariableList.Variable.Type,
                            Forced: aData.VariableList.Variable.Forced,
                            ReadOnly: aData.VariableList.Variable.ReadOnly,
                            System: wSys,
                            // GroupVariable: "Client"
                        },
                    ],
                },
            };
            varList = [...wdata.VariableList.Variable];
        } else {
            if (aData.VariableList.Variable.length !== 0) {
                varList = getArray(aData.VariableList.Variable);
            } else {
                varList = [];
            }
        }
        return varList;
    }
}
